import { render, staticRenderFns } from "./PassageDetail.vue?vue&type=template&id=43cdde10&scoped=true"
import script from "./PassageDetail.vue?vue&type=script&lang=js"
export * from "./PassageDetail.vue?vue&type=script&lang=js"
import style0 from "./PassageDetail.vue?vue&type=style&index=0&id=43cdde10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cdde10",
  null
  
)

export default component.exports